import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ColumnComponent } from '../column.component';
import { AsyncPipe, NgIf, NgStyle } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { exists } from '../../../../../functions/exists';
import { SectionColumnCannabinoidType } from '../../../../../models/enum/shared/section-column-cannabinoid-type';
import type { SectionColumnConfigDataValue } from '../../../../../models/enum/shared/section-column-config-data-value';
import { ColumnListLayoutModifierClass } from 'src/app/models/enum/shared/column-list-layout-types';
import { BadgeAsset } from 'src/app/models/image/dto/badge-asset';

@Component({
  selector: 'app-column-cannabinoid',
  imports: [AsyncPipe, NgIf, NgStyle, SharedModule],
  templateUrl: './column-cannabinoid.component.html',
  styleUrl: './column-cannabinoid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ColumnCannabinoidComponent extends ColumnComponent implements AfterViewInit, OnChanges, OnInit {
  constructor(protected renderer: Renderer2) {
    super();
  }
  @ViewChild('cannabinoidColumn') cannabinoidColumn: ElementRef<HTMLDivElement>;
  @Input() useNgContent: boolean;
  @Input() cannabinoidColumnType: keyof typeof SectionColumnCannabinoidType;
  @Input() displayFormat: SectionColumnConfigDataValue;
  @Input() columnListLayoutModifierClass: ColumnListLayoutModifierClass = null;

  private currentCannabinoidClass: string;
  isThcAndCbdColumn: boolean;
  isTopCannabinoid: boolean;
  isListCannabinoidColumn: boolean;
  isOtherColumn: boolean;

  ngOnInit(): void {
    super.ngOnInit();
    this.isThcAndCbdColumn = this.colVm.columnType === SectionColumnCannabinoidType.THCAndCBD;
    this.isTopCannabinoid = this.colVm.columnType === SectionColumnCannabinoidType.TopCannabinoid;
    this.isListCannabinoidColumn = this.colVm.columnType === SectionColumnCannabinoidType.ListCannabinoids;
    this.isOtherColumn = !(this.isThcAndCbdColumn || this.isTopCannabinoid || this.isListCannabinoidColumn);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cannabinoidColumnType) this.updateClass();
  }

  getNonListColumnItem(): BadgeAsset | string | undefined {
    if (this.colVm.columnConfigDataValueIsBadgeMode()) {
      return this.rowVm.getBadgeAssetForColumnType(SectionColumnCannabinoidType.TopCannabinoid)?.image;
    }
    return this.rowVm.getTopCannabinoid();
  }

  private updateClass(): void {
    if (exists(this.cannabinoidColumn?.nativeElement)) {
      this.renderer.removeClass(this.cannabinoidColumn.nativeElement, this.currentCannabinoidClass);
      this.currentCannabinoidClass = `product-${this.cannabinoidColumnType?.toLowerCase()}`;
      this.renderer.addClass(this.cannabinoidColumn?.nativeElement, this.currentCannabinoidClass);
    }
  }
}
